import {
  FlightSearchResult,
  ManualTransport,
  SelectedTransport,
  TransportDataSource,
  TransportType,
} from "@/core/types/types";
import { FLIGHT_NUMBER_REGEX } from "@/components/custom/AlternativeTransportation/Transportations/ManualTransports/ManualTransportInput/fields";

const transportMapper = {
  fromSearchResult: (
    flightSearchResult: FlightSearchResult,
    transportOrder: number
  ): SelectedTransport => {
    const flightNumber = resolveFlightNumber(
      flightSearchResult.operatingAirlineCode,
      flightSearchResult.flightNumber
    );

    return {
      flightNumber,
      transportRouteOrder: String(transportOrder + 1),
      transportTypeName: TransportType.plane,
      departureAirportIata: flightSearchResult.departureAirportIata,
      arrivalAirportIata: flightSearchResult.arrivalAirportIata,
      transportDataSource: TransportDataSource.FlightDataApi,
      airlineIata: flightSearchResult.operatingAirlineCode,
      scheduledDepartureDateTime: flightSearchResult.scheduledDeparture,
      scheduledArrivalDateTime: flightSearchResult.scheduledArrival,
      actualArrivalDateTime: flightSearchResult.actualArrival,
      actualDepartureDateTime: flightSearchResult.actualDeparture,
    };
  },

  fromManualTransport: (
    manualTransport: ManualTransport
  ): SelectedTransport => {
    return {
      transportRouteOrder: String(manualTransport.transportRouteOrder + 1),
      transportTypeName: manualTransport.transportTypeName,
      departureAirportIata: manualTransport.departureAirportIata,
      arrivalAirportIata: manualTransport.arrivalAirportIata,
      airlineIata: manualTransport.airlineIata,
      transportDataSource: TransportDataSource.Manual,
      flightNumber: manualTransport.flightNumber,
      scheduledDepartureDateTime: manualTransport.scheduledDepartureTime,
      scheduledArrivalDateTime: manualTransport.scheduledArrivalTime,
      actualDepartureDateTime:
        manualTransport.transportTypeName !== TransportType.plane
          ? manualTransport.scheduledDepartureTime
          : undefined,
      actualArrivalDateTime:
        manualTransport.transportTypeName !== TransportType.plane
          ? manualTransport.scheduledArrivalTime
          : undefined,
    };
  },
};

const resolveFlightNumber = (airlineIATA: string, flightNumber: string) => {
  const flightNumberRegex = new RegExp(FLIGHT_NUMBER_REGEX);
  return flightNumberRegex.test(flightNumber)
    ? flightNumber
    : airlineIATA + flightNumber;
};

export { transportMapper, resolveFlightNumber };
